import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

// Largest slidesPerView in breakpoints; used to decide how many slides Swiper needs.
const GALLERY_MAX_SLIDES_PER_VIEW = 3.55;


export function initGallerySlider() {
  if (typeof Swiper === "undefined") {
    return;
  }

  const sections = document.querySelectorAll(".gallery-slider");
  if (sections.length === 0) {
    return;
  }

  sections.forEach((section, instanceIndex) => {
    initOneGallerySlider(section, instanceIndex);
  });
}

function initOneGallerySlider(section, instanceIndex) {
  if (section.dataset.gallerySliderInitialized === "true") {
    return;
  }

  const el = section.querySelector(".gallery-slider__swiper");
  const btnPrev = section.querySelector(".gallery-slider__nav-btn--prev");
  const btnNext = section.querySelector(".gallery-slider__nav-btn--next");

  if (!el) {
    return;
  }

  const wrapper = el.querySelector(".swiper-wrapper");
  if (!wrapper) {
    return;
  }

  const originals = Array.from(wrapper.querySelectorAll(".swiper-slide"));
  if (originals.length === 0) {
    return;
  }

  const minSlides = Math.ceil(GALLERY_MAX_SLIDES_PER_VIEW * 2);

  originals.forEach((slide, i) => {
    const link = slide.querySelector("a.glightbox");
    if (link) {
      link.dataset.galleryItemIndex = String(i);
    }
  });

  let appended = 0;
  let sourceRotor = 0;
  while (originals.length + appended < minSlides) {
    const source = originals[sourceRotor % originals.length];
    const clone = source.cloneNode(true);
    const cloneLink = clone.querySelector("a.glightbox");
    if (cloneLink) {
      cloneLink.classList.add("gallery-slider__lightbox--swiper-clone");
      cloneLink.setAttribute("tabindex", "-1");
    }
    wrapper.appendChild(clone);
    appended += 1;
    sourceRotor += 1;
  }

  const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    rewind: true,
    speed: 1000,
    grabCursor: true,
    loop: true,
    keyboard: { enabled: true, onlyInViewport: true },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: "Previous image",
      nextSlideMessage: "Next image",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3.55,
        spaceBetween: 24,
      },
    },
  };

  if (btnPrev && btnNext) {
    swiperOptions.navigation = {
      prevEl: btnPrev,
      nextEl: btnNext,
    };
  }

  const swiper = new Swiper(el, swiperOptions);

  bindSwiperAutoplayToViewport(swiper);

  const scopeId = section.id || `gallery-slider-${instanceIndex}`;
  if (!section.id) {
    section.id = scopeId;
  }

  const lightboxSelector = `#${CSS.escape(scopeId)} .glightbox:not(.gallery-slider__lightbox--swiper-clone)`;
  const hasLightboxSource = Boolean(
    section.querySelector("a.glightbox:not(.gallery-slider__lightbox--swiper-clone)")
  );
  let lightbox = null;
  if (typeof GLightbox !== "undefined" && hasLightboxSource) {
    lightbox = GLightbox({
      selector: lightboxSelector,
      loop: true,
    });
  }

  if (lightbox) {
    el.addEventListener("click", (e) => {
      const link = e.target.closest("a.gallery-slider__lightbox--swiper-clone");
      if (!link) {
        return;
      }
      e.preventDefault();
      const idx = parseInt(link.dataset.galleryItemIndex, 10);
      if (!Number.isNaN(idx)) {
        lightbox.openAt(idx);
      }
    });
  }

  section.dataset.gallerySliderInitialized = "true";
}
